






































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TablePager from '@/components/TablePager.vue';
import TableField from '@/types/TableField';
import TableSortEventArgs from '@/types/TableSortEventArgs';
import EntityReference from '@/types/EntityReference';
import { BTable, BButton, BIconArrowUp, BIconArrowDown, BSpinner } from 'bootstrap-vue';
import Configuration from '@/types/Configuration';
import PerformedWorkFilterOptions from '@/types/PerformedWorkFilterOptions';
import PerformedWorkListOptions from '@/types/PerformedWorkListOptions';
import DateTime from '../types/DateTime';
import InlineSvg from 'vue-inline-svg';
import ColumnHeader from '@/components/ColumnHeader.vue';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';
import { InitPagerOptions } from '@/types/PagerOptions';
import Authorization, { PermissionScope } from '../types/Authorization';

@Component({
    components: {
        'table-pager': TablePager,
        'b-table': BTable,
        'b-btn': BButton,
        'b-icon-arrow-up': BIconArrowUp,
        'b-icon-arrow-down': BIconArrowDown,
        'inline-svg': InlineSvg,
        'column-header': ColumnHeader,
        'b-spinner': BSpinner
    }
})
export default class PerformedWorkList extends Vue {
    @Prop() refresh!: boolean
    @Prop() filter!: PerformedWorkFilterOptions

    performedWorks: PerformedWorkListItem[] = [];
    listOptions: PerformedWorkListOptions = {
        filter: this.filter,
        pagerOptions: {
            page: 1,
            pageSize: Configuration.DefaultPageSize,
            pageCount: 1,
            rowCount: 0,
            rowStart: 0,
            rowEnd: 0
        },
        sortOptions: {
            sortBy: 'date',
            sortDirection: Configuration.SortDirectionDescending
        }
    };
    isBusy = false;
    apiAccessToken = this.$store.state.apiAccessToken;
    fields: TableField[] = [];

    @Watch('refresh')
    refreshList(newVal: boolean) {
        if (newVal) {
            this.loadPerformedWork();
        }
    }

    @Watch('filter')
    filterList(newVal: PerformedWorkFilterOptions) {
        this.listOptions.filter = newVal;
        this.listOptions.pagerOptions.page = 1;
    }

    get canViewUserInList() {
        //TODO
        //return Authorization.checkAccessRights(this.$appUser, Authorization.operations.viewUserInPerformedWorkList);
        return true;
    }

    canEditPerformedWork(performedWork: PerformedWorkListItem) {
        return (Authorization.checkAccessRights(this.$appUser, Authorization.operations.editMyPerformedWork, performedWork.project.id as string, PermissionScope.Project) && this.$appUser?.id == performedWork.user.id)
            || Authorization.checkAccessRights(this.$appUser, Authorization.operations.editPerformedWorkForAllowedProjects, undefined, PermissionScope.Project);
    }

    mounted() {
        this.isBusy = false;
        this.initFields();
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadPerformedWork();
        this.$root.$on('LocaleChanged', this.onLocaleChanged);
        this.$emit("list-options-initialized", this.listOptions);
    }

    unmounted() {
        this.$root.$off('LocaleChanged');
    }

    initFields() {
        this.fields = [
            {
                key: 'sequenceId',
                label: this.$t('fields.id').toString(),
                headerTitle: 'Id',
                sortable: true,
                thStyle: 'width: 75px',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg font-weight-bolder py-4',
                formatter: null
            },
            {
                key: 'user',
                label: this.$t('fields.user').toString(),
                headerTitle: 'User',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg font-weight-bolder py-4',
                formatter: null
            },
            {
                key: 'date',
                label: this.$t('fields.date').toString(),
                headerTitle: 'Date',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-primary font-size-lg font-weight-bolder py-4',
                formatter: (item: string) => {
                    return DateTime.toLocal(item, DateTime.formats.date);
                }
            },
            {
                key: 'projectTask',
                label: this.$t('fields.projectTask').toString(),
                headerTitle: 'ProjectTask',
                sortable: false,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'datatable-cell text-dark-75 font-size-lg font-weight-bolder py-4',
                formatter: null
            },
            {
                key: 'identifierActivity',
                label: this.$t('fields.identifierActivity').toString(),
                headerTitle: 'IdentifierActivity',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'datatable-cell text-dark-75 font-size-lg py-4',
                formatter: null
            },
            {
                key: 'duration',
                label: this.$t('fields.duration').toString(),
                headerTitle: 'Duration',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-right text-nowrap datatable-cell text-dark-75 font-size-lg py-4',
                formatter: null
            },
            {
                key: 'actions',
                label: '',
                headerTitle: '',
                sortable: false,
                thStyle: '',
                thClass: 'columnheader',
                tdClass: 'pl-3 pr-1 py-2 text-right text-nowrap',
                formatter: null
            }
        ];

        if (!this.canViewUserInList) {
            this.fields.splice(this.fields.findIndex(function (f) {
                return f.key === 'user';
            }), 1);
        }
    }

    async loadPerformedWork() {
        try {
            const response = await AxiosService.request<ServerData>({
                url: `performedwork/list`,
                method: 'POST',
                data: this.listOptions
            });
            this.performedWorks = response.data.records.map(pw => {
                const obj = pw;
                obj.date = DateTime.toUtc(pw.date, DateTime.formats.date);
                obj.identifierActivity = pw.identifier != null ? `${pw.identifier} - ${pw.activity}` : pw.activity
                return obj;
            }) ?? [];
            this.listOptions.pagerOptions = InitPagerOptions(response.data.totalRecordCount, response.data.pageCount, this.listOptions.pagerOptions.page, this.listOptions.pagerOptions.pageSize);
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
            this.$emit('load-complete', this.listOptions.pagerOptions.rowCount);
        }
    }

    editPerformedWork(id: string) {       
        this.$emit('performed-work-opened', id);
    }

    deletePerformedWork(id: string) {
        this.$bvModal.msgBoxConfirm(this.$t('modal.confirmPerformedWorkDeleteMessage') as string, {
            title: this.$t('modal.confirmPerformedWorkDeleteTitle') as string,
            centered: true,
            buttonSize: 'sm',
            okTitle: this.$t('modal.confirmOkTitle') as string,
            cancelTitle: this.$t('modal.confirmCancelTitle') as string
        })
        .then(value => {
            if (value) {
                try {
                    AxiosService.request<ServerData>({
                        url: `performedwork?id=${id}`,
                        method: 'DELETE'
                    });

                    this.$root.$bvToast.toast(this.$t('toaster.performedWorkDeleted') as string, {
                        title: this.$t('toaster.deletePerformedWorkTitle') as string,
                        autoHideDelay: Configuration.ToasterAutoHideDelay,
                        appendToast: true,
                        variant: Configuration.ToasterVariantSuccess,
                        toaster: Configuration.ToasterPosition
                    });
                    this.loadPerformedWork();
                }
                catch (error) {
                    if (error.response) {
                        switch (error.response.status) {
                            case 404:
                                return this.$router.push(`/${i18n.locale}/notfound`);
                            case 403:
                                return this.$router.push(`/${i18n.locale}/accessdenied`);
                            default:
                                return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                        }
                    }
                }
                finally {
                    this.isBusy = false;
                }
            }
        })
        .catch(error => {
            console.error(error);
        });
    }

    getLocalDateString(date: moment.Moment) {
        return DateTime.toLocalString(date, DateTime.formats.date);
    }

    onChangePage(page: number) {
        this.listOptions.pagerOptions.page = page;
        this.loadPerformedWork();
    }

    onChangePageSize(pageSize: number) {
        this.listOptions.pagerOptions.pageSize = pageSize;
        this.listOptions.pagerOptions.page = 1;
        this.loadPerformedWork();
    }

    onSortChanged(e: TableSortEventArgs) {
        this.listOptions.sortOptions.sortBy = e.sortBy;
        this.listOptions.sortOptions.sortDirection = e.sortDesc ? -1 : 1;
        this.loadPerformedWork();
        this.$emit("list-options-initialized", this.listOptions);
    }

    onRowClicked(e: PerformedWorkListItem) {
        this.$emit('performed-work-selected', e.id);
    }

    onLocaleChanged(locale: string) { // eslint-disable-line @typescript-eslint/no-unused-vars
        this.$nextTick(() => {
            DateTime.setLocale(locale);
            this.initFields();
        });
    }
}

interface ServerData {
    records: PerformedWorkListItem[];
    totalRecordCount: number;
    pageCount: number;
}

interface PerformedWorkListItem {
    id: string;
    sequenceId: number;
    date: moment.Moment | undefined;
    project: EntityReference;
    task: EntityReference;
    activity: string;
    identifier: string | null;
    identifierActivity: string;
    duration: number;
    user: EntityReference;
}
